import * as style from './styles.css';
import { clsx } from 'clsx';
import { Button, useDeviceType } from '@cian/ui-kit';
import { Experiment } from '@cian/experiments/ab';
import { EModalSource } from 'shared/common/types/modal';
import { HOW_IT_WORKS } from 'shared/landingSeller/constants/howItWorks';
import { B2B_PA17109_REALTOR_COMMISSION_KNOWLEDGE } from 'shared/common/constants/experiments';

export const HowItWorks: React.FC<{
  onOpenModal: (EModalSource: string) => void;
  userId?: number;
  source?: string;
  agentCommissionRef?: React.RefObject<HTMLDivElement>;
}> = ({ onOpenModal, agentCommissionRef }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>Пройдём с вами весь путь</div>
      <div className={style['list']}>
        {HOW_IT_WORKS.map(({ id, title, description, imageClass }) => (
          <div key={id} className={style['item']}>
            <div className={style['item-textblock']}>
              <div className={style['item-id']}>{id}</div>
              <div className={style['item-title']}>{title}</div>
              <div className={style['item-descr']}>{description}</div>
            </div>
            <div className={clsx(style['item-image'], style[imageClass])} />
          </div>
        ))}
      </div>
      <div ref={agentCommissionRef} className={style['notice']}>
        <Experiment name={B2B_PA17109_REALTOR_COMMISSION_KNOWLEDGE} group="Control" default>
          <div className={style['notice-title']}>Без предоплат и&nbsp;скрытых комиссий</div>
          <div className={style['notice-descr']}>Оплата только агенту и только после сделки</div>
        </Experiment>
        <Experiment name={B2B_PA17109_REALTOR_COMMISSION_KNOWLEDGE} group="Test">
          <div className={style['notice-title']}>
            Вы оплачиваете только услуги риелтора и только
            <br />
            после сделки
          </div>
          <div className={style['notice-descr']}>Без предоплат и скрытых комиссий. Комиссия риелтора 2,5–3%.</div>
        </Experiment>
      </div>
      <div className={style['button']}>
        <Button
          size="L"
          fullWidth={device !== 'desktop' && device !== 'tablet'}
          onClick={() => onOpenModal(EModalSource.Consultation)}
        >
          Расскажите ещё подробнее
        </Button>
      </div>
    </div>
  );
};
